/**
 * CouponDashboardPresenter
 * --
 */
import React from 'react';
import { Content, Title, Row, Col, ExpandableContainer } from 'components';
import { Divider, Button, Table, Radio, Spin, Statistic } from 'antd';
import {
  SearchOutlined,
  ReloadOutlined,
  ExportOutlined,
} from '@ant-design/icons';
import {
  CartesianGrid,
  Tooltip,
  BarChart,
  ResponsiveContainer,
  XAxis,
  YAxis,
  Legend,
  Bar,
} from 'recharts';
import { stringToMoneyFormat } from 'utils';
import moment from 'moment';

/**----------------------------------------
 * [Component] 총관리자: 주문대시보드 - 프레젠터
 * ----------------------------------------
 */
const CouponDashboardPresenter = ({
  loading,
  couponData,
  // chartData,
  // statisticsType,
  // setStatisticsType,
  // handleGetCartList,
}) => {
  /* ===== ROUTE ===== */
  /* ===== PROPS ===== */
  /* ===== STATE ===== */

  /* ===== VARIABLE ===== */
  // const formItem = [
  //   {
  //     label: '기간설정',
  //     form: [
  //       {
  //         input: (
  //           <>
  //             <Radio.Group
  //               size="large"
  //               defaultValue="month"
  //               buttonStyle="solid"
  //               value={statisticsType}
  //               onChange={(e) => setStatisticsType(e.target.value)}
  //               style={{ marginRight: 12 }}
  //             >
  //               <Radio.Button value="today">오늘</Radio.Button>
  //               <Radio.Button value="week">1주일(7일)</Radio.Button>
  //               <Radio.Button value="month">1개월(30일)</Radio.Button>
  //               <Radio.Button value="3month">3개월(90일)</Radio.Button>
  //             </Radio.Group>
  //           </>
  //         ),
  //       },
  //     ],
  //   },
  // ];

  /* ===== FUNCTION ===== */
  /* ===== HOOKS ===== */

  // 할인권 목록
  const discountCouponList = !couponData
    ? []
    : couponData.filter(
        (item) =>
          item.voucher_type === 'AMOUNT_DISCOUNT' ||
          item.voucher_type === 'PERCENT_DISCOUNT'
      );
  // 교환권 목록
  const exchangeCouponList = !couponData
    ? []
    : couponData.filter((item) => item.voucher_type === 'EXCHANGE');

  /* ===== RENDER ===== */
  // JSX: start
  return (
    <Spin spinning={loading}>
      <Content maxWidth={'100%'} padding={20} backgroundColor={'none'}>
        <Row>
          <Col x={24}>
            <Title size={3} style={{ marginBottom: 12 }}>
              쿠폰 대시보드
            </Title>

            {/* 검색필터 */}
            {/* <Content
              maxWidth={'100%'}
              padding={0}
              // backgroundColor={'none'}
              style={{ marginBottom: 5 }}
            >
              <Row>
                <Col x={19}>
                  <ExpandableContainer borderRadius={4} padding={20}>
                    {formItem.map((_item, _index) => (
                      <div
                        key={`form_${_index}`}
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          padding: '10px 0px',
                        }}
                      >
                        <div
                          style={{ width: 120, fontSize: 13, fontWeight: 400 }}
                        >
                          <label>{_item.label}</label>
                        </div>
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                          {_item.form.map((_subitem, _subkey) => (
                            <React.Fragment key={`input_${_subkey}`}>
                              {_subitem.input}
                            </React.Fragment>
                          ))}
                        </div>
                      </div>
                    ))}
                  </ExpandableContainer>
                </Col>
                <Col
                  x={5}
                  style={{
                    justifyContent: 'center',
                    alignItems: 'center',
                    display: 'flex',
                  }}
                >
                  <Button
                    size="large"
                    type="primary"
                    onClick={() => handleGetCartList()}
                  >
                    <SearchOutlined /> 검색
                  </Button>
                  &nbsp;
                  <Button
                    size="large"
                    // onClick={handleResetFilter}
                  >
                    <ReloadOutlined /> 초기화
                  </Button>
                </Col>
              </Row>
            </Content> */}
            {/* 검색필터 끝 */}

            {/* === 현황 요약: start === */}
            <Content
              fullWidth
              padding={0}
              backgroundColor={'none'}
              style={{
                marginBottom: 5,
                display: 'flex',
                justifyContent: 'space-between',
              }}
            >
              {[
                {
                  title: '전체쿠폰',
                  value: stringToMoneyFormat(couponData?.length ?? 0),
                  suffix: '건',
                  link: '/coupon/list',
                },
                {
                  title: '발급된 수량',
                  value: stringToMoneyFormat(
                    !couponData
                      ? 0
                      : couponData.reduce(
                          (acc, cur) => (acc += cur.coupon_use_num),
                          0
                        )
                  ),
                  suffix: '개',
                },
                {
                  title: '할인권',
                  value: stringToMoneyFormat(discountCouponList?.length ?? 0),
                  suffix: '개',
                },
                {
                  title: '할인권 발급수량',
                  value: stringToMoneyFormat(
                    discountCouponList.reduce(
                      (acc, cur) => (acc += cur.coupon_use_num),
                      0
                    )
                  ),
                  suffix: '개',
                },
                {
                  title: '교환권',
                  value: stringToMoneyFormat(exchangeCouponList?.length ?? 0),
                  suffix: '개',
                },
                {
                  title: '교환권 발급수량',
                  value: stringToMoneyFormat(
                    exchangeCouponList.reduce(
                      (acc, cur) => (acc += cur.coupon_use_num),
                      0
                    )
                  ),
                  suffix: '개',
                },
              ].map((_item, _index) => (
                <div
                  key={`${_item.label}-${_index}`}
                  className="boxShadow"
                  style={{
                    background: '#FFFFFF',
                    borderRadius: 4,
                    width: `90%`,
                    margin: '0 2px',
                    padding: '24px 15px',
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                  }}
                >
                  <Statistic
                    className="cursorOverOpacity"
                    direction={'row'}
                    size="large"
                    title={_item.title}
                    value={_item.value}
                    suffix={_item.suffix}
                    // style={{ justifyContent: 'center' }}
                    valueStyle={{
                      color: '#1677ff',
                      textDecoration: 'underline !important',
                    }}
                  />
                  <div>
                    {/* <Button shape="circle">
                      <ExportOutlined />
                    </Button> */}
                  </div>
                </div>
              ))}
            </Content>
            {/* === 현황 요약: end === */}

            {/* ===== 차트: start ===== */}
            <Row gutter={[5, 5]}>
              {/* === 상품별: start === */}
              <Col x={12}>
                <Content
                  maxWidth={'100%'}
                  borderRadius={4}
                  padding={16}
                  height={600}
                  style={{ overflowX: 'auto' }}
                >
                  <Title size={5}>쿠폰별 사용량(Top 10)</Title>

                  <Divider style={{ margin: '18px 0' }} />
                  <ResponsiveContainer
                    width="92%"
                    height={500}
                    style={{ marginTop: 15, margin: '0 auto' }}
                  >
                    <BarChart
                      width={500}
                      height={360}
                      layout={'vertical'}
                      data={
                        !couponData
                          ? []
                          : couponData?.slice(0, 10).map((item) => ({
                              ...item,
                              ['쿠폰명']: item?.coupon_name ?? '',
                              ['사용량']: item?.coupon_use_num ?? 0,
                              ['발급가능']: item?.coupon_issue_num ?? 0,
                            }))
                      }
                      margin={{
                        top: 5,
                        right: 30,
                        left: 20,
                        bottom: 5,
                      }}
                    >
                      <CartesianGrid strokeDasharray="3 3" />
                      <XAxis type={'number'} dataKey={'사용량'} />
                      <YAxis type={'category'} dataKey={'쿠폰명'} />
                      <Tooltip />
                      <Legend />
                      <Bar dataKey="발급가능" fill="#8884d8" />
                      <Bar dataKey="사용량" fill="#82ca9d" />
                    </BarChart>
                  </ResponsiveContainer>
                </Content>
              </Col>
              {/* === 상품별: end === */}

              {/* === 내역: start === */}
              <Col x={12}>
                <Content
                  maxWidth={'100%'}
                  height={600}
                  borderRadius={4}
                  // padding={'14px 5px'}
                >
                  <Title size={5} style={{ marginBottom: 12 }}>
                    쿠폰목록({couponData?.length ?? 0}개)
                  </Title>

                  <Table
                    bordered
                    size="small"
                    scroll={{ x: 650, y: 500 }}
                    pagination={false}
                    dataSource={couponData ?? []}
                    columns={[
                      {
                        title: '쿠폰명',
                        dataIndex: 'coupon_name',
                        width: 200,
                        align: 'center',
                      },
                      {
                        title: '지급유형',
                        dataIndex: 'payment_type',
                        width: 100,
                        align: 'center',
                        render: (v) => (
                          <>
                            {v === 'MANUAL' && '수동지급'}
                            {v === 'AUTOMATIC' && '자동지급'}
                            {v === 'DOWNLOAD' && '다운로드'}
                            {v === 'STAMP' && '스템프'}
                          </>
                        ),
                      },
                      {
                        title: '만료타입',
                        dataIndex: 'expiration_type',
                        width: 100,
                        align: 'center',
                        render: (v) => (
                          <>
                            {v === 'FIXED' && '만료일기준'}
                            {v === 'ROLLING' && '발급일기준'}
                          </>
                        ),
                      },
                      {
                        title: '발급가능수량',
                        dataIndex: 'coupon_issue_num',
                        width: 120,
                        align: 'center',
                        render: (value) =>
                          `${
                            value === 0 ? '무제한' : stringToMoneyFormat(value)
                          }`,
                      },
                      {
                        title: '사용량',
                        dataIndex: 'coupon_use_num',
                        width: 120,
                        align: 'center',
                        render: (value) => `${stringToMoneyFormat(value)}`,
                      },
                      {
                        title: '다운만료일',
                        dataIndex: 'end_date',
                        width: 120,
                        align: 'center',
                        render: (value) =>
                          `${moment(value * 1000).format('YYYY-MM-DD')}`,
                      },
                      {
                        title: '쿠폰코드',
                        dataIndex: 'coupon_code',
                        width: 120,
                        align: 'center',
                        render: (v) => (
                          <p
                            style={{
                              fontSize: '0.8em',
                              opacity: 0.5,
                              letterSpacing: -0.35,
                            }}
                          >
                            {v}
                          </p>
                        ),
                      },
                    ]}
                  />
                </Content>
              </Col>
              {/* === 내역: end === */}
            </Row>
            {/* ===== 차트: end ===== */}
          </Col>
        </Row>
      </Content>
    </Spin>
  ); // JSX: end
};

export default CouponDashboardPresenter;
